



































































































































import { Component, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CreateCampaignDialogFlowPath from './create-campaign-dialog-flow-path.vue';

import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';
import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import ConstantsHelperMixin from '@/components/helpers/constants-helper-mixin';
import CreateCampaignDialogFlowRuleErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-rule-errors-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
    CreateCampaignDialogFlowPath
  }
})
export default class CreateCampaignDialogFlowRule extends
  mixins(
    FlowMixin,
    ConstantsHelperMixin,
    BasicHelperMixin,
    mixins(
      PlanLimitsMixin,
      CreateCampaignDialogFlowRuleErrorsMixin
    )
  ) {
  @Prop()
  ruleIndex: number;

  @Prop({ default: false })
  isDisabledWeight: boolean;

  @Prop()
  rule: any;

  @Prop()
  offerOptions: Offer[];

  @Prop()
  landingOptions: Landing[];

  @Prop()
  form: any;

  @Prop()
  countryId: string;

  @Prop()
  landings: any[];

  @Prop()
  offers: any[];

  @Prop({ default: () => [] as string[] })
  errorConditionPrefix: string[];

  @Prop() 
  dialogRepositionParam: string;

  @Emit('add-new-rule')
  onAddNewRule(rule: any) {}
 
  get showPlanLimitsWarning(){
    return Object.keys(this.rule.conditions).find((condition)=>{
      return this.hasPlanLimitsRestriction(this.conditionPlanLimits(condition))
    })
  }

  translatedName(name:string) {
    if(name==='Default') return this.t('Default')
    return name;
  }

  get errorCondition(): any[] {
    return [
      ...this.errorConditionPrefix,
      ...this.getRuleErrorCondition(this.ruleIndex)
    ];
  }

  get $FFReportingFlowRulePathEnabled() {
    return this.$FF?.reportingFlowRulePath?.enabled;
  }

  get ruleConditions() {
    const { conditions } = this.rule;
    const item = { conditions };

    if(item) {
      let result = this.generate_name(item, false);

      if (result.length > 1) {
        return [
          result[0],
          {
            black:true,
            name:` (${this.tc('+{0} conditions', result.length - 1, [result.length - 1])})`
          }
        ]
      }

      return result;
    }

    return '';
  }

  addNewPath(rule: any) {
    let last_item = (rule.lastPathNumber || rule.paths.length) + 1;
    rule.lastPathNumber = last_item;
    rule.paths.push({
      name: this.t('Path') + ' ' + last_item,
      weight: 100,
      status: 'active',
      redirectMode: '302',
      directLinking: false,
      landings: [],
      offers: []
    });
  }

  deleteRule() {
    this.bus.emit('campaign-delete-rule', this.ruleIndex);
  }
}
